/** Namespace `planMapping` — bản gốc tiếng Việt. Khoá phẳng, tên camelCase; `{biến}` để chèn. */
export const planMapping = {
  title: "Ánh xạ gói",
  subtitleBefore: "Quy gói nguyên bản của từng nguồn về trục chung năm bậc. Gói chưa ánh xạ",
  subtitleStrong: "không",
  subtitleAfter: "rơi vào « free » — chúng nằm riêng ở « chưa ánh xạ ».",
  loadFailed: "Không đọc được danh sách gói.",
  saveFailed: "Không lưu được ánh xạ.",
  mapped:
    "Đã ánh xạ « {name} » về bậc {tier}. Số liệu các kỳ đã qua giữ nguyên — ánh xạ mới tính từ lượt quét tiếp theo.",
  unmappedBanner: "gói chưa quy về trục chung. Khách hàng của chúng không xuất hiện đúng chỗ trong bảng theo bậc.",
  emptyApp: "App này chưa khai gói nào.",
  emptyAll: "Chưa có gói nào được khai.",
  emptyHint:
    "Worker ghi danh sách gói mỗi lượt quét — nguồn nào không có khái niệm gói thì không có dòng nào ở đây, và đó là đúng.",
  "col.source": "Nguồn",
  "col.nativePlan": "Gói của nguồn",
  "col.customers": "Khách hàng",
  "col.interval": "Chu kỳ",
  "col.price": "Giá",
  "col.tier": "Bậc chung",
  "col.mappedBy": "Ai ánh xạ",
  unmapped: "Chưa ánh xạ",
  footnote:
    "Giá và chu kỳ lấy từ chính nguồn. Trống nghĩa là nguồn khai bảng giá trong mã chứ không trong cơ sở dữ liệu — hub không đoán, và vì vậy không tính doanh thu định kỳ cho nguồn đó.",
  everyMonth: "mỗi tháng",
  everyYear: "mỗi năm",
  everyNMonths: "mỗi {count} tháng",
  everyNYears: "mỗi {count} năm",
} as const;
